import React from 'react';
import PropTypes from 'prop-types';
import { resolveWorksuiteImageUrl } from '../../../utils/resolveWorksuiteImageUrl';

export const ProfileImage = ({ profilePicture }) => {
  if (profilePicture) {
    return <img src={resolveWorksuiteImageUrl(profilePicture)} className="profile-image" />;
  }
  return <></>;
};

ProfileImage.propTypes = {
  profilePicture: PropTypes.string
};

ProfileImage.defaultProps = {
  profilePicture: ''
};
